/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  /**
   * Weight to render the SVG in. Defaults to "normal"
   */
  weight?: "thin" | "normal";
}
export const IconSuccessSolid = ({
  fill = "none",
  stroke = "currentColor",
  weight = "normal",
  ...props
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    css={css`
      * {
        vector-effect: non-scaling-stroke;
      }
      overflow: visible;
      height: 24px;
    `}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0m6.9 8.2-6.8 9.3c-.3.4-1 .5-1.4.2l-4.9-3.9c-.4-.3-.5-1-.2-1.4s1-.5 1.4-.2l4.1 3.3L17.3 7c.3-.5.9-.6 1.4-.3s.6 1 .2 1.5c.1 0 0 0 0 0"
    />
    <path
      fill="transparent"
      d="m18.9 8.2-6.8 9.3c-.3.4-1 .5-1.4.2l-4.9-3.9c-.4-.3-.5-1-.2-1.4s1-.5 1.4-.2l4.1 3.3L17.3 7c.3-.5.9-.6 1.4-.3s.6 1 .2 1.5c.1 0 0 0 0 0"
      className="inner"
    />
  </svg>
);
